import { actions } from "react-redux-form";
import { httpDownload, httpPost } from "../../../../utils/api.utils";
import {
    setHrUploadError
    , getHrUploadTypes
    , HrUploadModel } from "../../../../constants/model-reducers/external/manage-user/hr-upload/hr-upload.settings";

export const hrUploadFormInitialState = HrUploadModel;

const defaultState = () => ({
    hrUploadTypeOptions: [],
    hrUploadError: false
});

const initialState = defaultState();

export const HrUploadTypeAction = {
    getHrUploadTypes: () => async (dispatch, state) => {
        var res = await httpPost('external/hrupload/getHrUploadTypes');

        if (res.ok === false) {
            dispatch({
                type: setHrUploadError,
                hrUploadError: false,
                hrUploadTypeOptions: []
            })
        }
        else {
            dispatch({
                type: getHrUploadTypes,
                data: res
            });
        }
    },

    onHrUploadTypeSelect: (model, value) => async(dispatch, state) => {
        const intValue = parseInt(value);

        dispatch(actions.change(model, value));
        dispatch(actions.change("hrUploadForm.hrUploadTypeId", intValue))
    },

    postExecuteProcess: (UploadId) => () => {
        var url = 'external/adminupload/executePackage';

        httpPost(url, UploadId);
    },

    resetHrUploadForm: () => async (dispatch, state) => {
        dispatch(actions.reset('hrUploadForm.hrUploadTypeId'));
    },

    downloadHrUploadTemplate: (fileAttachmentModule, fileName) => async (dispatch, getState) => {
        const encodedFileName = encodeURIComponent(fileName);

        const dealName = sessionStorage.getItem('DealName');
        const newFileName = `ATEM ${dealName} - HR Upload Template.xlsx`;

        try {
            const response = await httpDownload(`common/fileAttachment/downloadFile/${fileAttachmentModule}/${encodedFileName}`);
            if (response.ok) {
                response.blob().then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, newFileName);
                    } else {
                        a.href = downloadUrl;
                        a.download = newFileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                });
            } else {
                dispatch({
                    type: setHrUploadError,
                    hrUploadError: false,
                })
            }
        } catch (error) {
            dispatch({
                type: setHrUploadError,
                hrUploadError: false,
            })
        }
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getHrUploadTypes:
            return {
                ...state,
                hrUploadTypeOptions: action.data
            }
        default:
            return state
    }
}